import { PointType } from '@src/common/constants';

export enum PremiumFeatures {
  OVERWRITE = 'overwrite_personalization',
  SCHEDULED = 'scheduled_launch',
  DYNAMIC = 'dynamic_delay'
}

export type PremiumModalType = PointType | PremiumFeatures;
